import API from "./axios";

export async function listVehicles({
  search = "",
  status = "all",
  category = "all",
  page = 1,
  limit = 10,
} = {}) {
  const params = { search, page, limit };
  if (category !== "all") params.category = category;
  if (status !== "all") params.status = status;

  const { data } = await API.get("/vehicle/getAllVehicle", { params });
  return {
    data: data?.data ?? [],
    pagination: data?.pagination ?? { total: 0, page, pages: 1, limit },
  };
}

export async function createVehicle(payload) {
  const { data } = await API.post("/vehicle/createVehicle", payload);
  return data;
}

export async function updateVehicle(id, patch) {
  const { data } = await API.put(`/vehicle/updateVehicle/${id}`, patch);
  return data;
}

export async function deleteVehicle(id) {
  const { data } = await API.delete(`/vehicle/delete/${id}`);
  return data;
}

export async function getVehicleCategories() {
  const { data } = await API.get("/vehicle/categories");
  return data.data;
}

export async function bulkUploadVehicles(file) {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await API.post("/vehicle/bulk-upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
